import HttpRequest from '../http_request'

class UserApi extends HttpRequest {
  apiGetNotification (data) {
    return this.fetch('/client/v1/notifications', data)
  }
  apiGetprofile (data) {
    return this.fetch('/client/v1/accounts', data)
  }
  apiGetverifyEmail(email){
    return this.fetch('/client/v1/accounts/email-verify', email)
  }

  apiEditreadNotification(id){
    return this.edit(`/client/v1/notifications/${id}/read`)
  }
  apiEditupdateConfigNoti(data){
    return this.edit(`/client/v1/accounts/profile`,data)
  }

  apiEditupdateProfile(data){
    return this.edit(`/client/v1/accounts/profile`,data)
  }

  apiEditupdateJuristicVerify(data){
    return this.edit(`/client/v1/accounts/juristic-verify`,data)
  }

  apiEditupdateCod(data){
    return this.edit(`/client/v1/accounts/cod-verify`,data)
  }

  apiEditupdatePeolpleNormal(data){
    return this.edit(`/client/v1/accounts/card-verify`,data)
  }

  apiCreateverifyEmailOtp(data){
    return this.create(`/client/v1/accounts/verify-email-otp`,data)
  }

  apiDeleteGetOtpForDelete(telephone){
    let dataRemove = { telephone: telephone }
    return this.remove(`/client/v1/accounts`,dataRemove)
  }

  apiDeleteAccount(data){
    let dataRemove = {
      telephone: data.telephone,
      otp: data.otp,
      ref: data.ref
    }
    return this.remove(`/client/v1/accounts`,dataRemove)
  }




  
}

export default UserApi
